module.exports = __webpack_public_path__ + "img/venuetwo-wzj.c4bd885c.png";